export default "__VITE_ASSET__BNeigt3A__"